import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import Diseases from "./Diseases";
import Medications from "./Medications";
import APIMaintenance from "../APIMaintenance";
import MedicationsInfo from "../disease-fund-detail/MedicationsInfo";

export default function FundMedicationListing({
  maintenance,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
}) {
  return (
    <Tabs className="Tabs">
      <div className="l-padding">
        <div className="l-wrap">
          <TabList className="Tabs-list u-mb4">
            <Tab className="Tabs-tab f-h3" style={{ position: "relative" }}>
              Medications
              <span style={{ position: "absolute", right: "-22px" }}>
                <MedicationsInfo />
              </span>
            </Tab>
          </TabList>
        </div>
      </div>

      <TabPanel className="Tabs-panel">
        {!maintenance && <Medications />}

        {maintenance && (
          <div
            className="Card u-mt8 u-mb8"
            style={{
              maxWidth: "640px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <div className="Card-inner">
              <div className="Card-inner-content">
                <APIMaintenance
                  line1={maintenanceMessageLine1}
                  line2={maintenanceMessageLine2}
                />
              </div>
            </div>
          </div>
        )}
      </TabPanel>
    </Tabs>
  );
}
